import { matchesPath } from './navigation'
import { PathTitles, PathTitleBundle } from '@shared/helpers/path-titles-list'

const DEFAULT_TITLE = 'Equa Start'
const NOT_FOUND_TITLE = 'Equa | Page Not Found'

export const PageTitles = () => {
  const path = window.location.pathname
  const match = PathTitles.find((item: PathTitleBundle) => matchesPath(item.path, path, false))
  if (match?.title) {
    document.title = `Equa | ${match.title()}`
    return
  }
  if (path === '/') {
    document.title = DEFAULT_TITLE
    return
  }
  document.title = NOT_FOUND_TITLE
}
